import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { InspectionStore } from '../../data/inspection/inspection.store';
import { RcipWizard } from './rcip/rcip-wizard/rcip-wizard';
import { RCIP_PRODUCT_ID } from './rcip/rcip-wizard.helpers';

// Loads the inspection, then hands it to the wizard for its product.
@Component({
  selector: 'app-inspection-page',
  templateUrl: './inspection-page.html',
  styleUrl: './inspection-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RcipWizard],
})
export class InspectionPage implements OnInit {
  protected store = inject(InspectionStore);
  protected readonly rcipProductId = RCIP_PRODUCT_ID;

  ngOnInit(): void {
    this.store.load();
  }
}
